import React from 'react';
import { Box, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Visual section grouping: small uppercase overline header + divider + grid of children.
 * Pass useGrid=false if you want raw children layout (no wrapping <Grid container>).
 */
export default function Section({ title, useGrid = true, spacing = 2, sx, children }) {
    return (
        <Box sx={{ mb: 3, ...sx }}>
            <Typography variant="overline" color="text.secondary" sx={{ fontWeight: 600, letterSpacing: '0.08em' }}>
                {title}
            </Typography>
            <Divider sx={{ mb: 2, mt: 0.5 }} />
            {useGrid
                ? <Grid container spacing={spacing}>{children}</Grid>
                : children
            }
        </Box>
    );
}

Section.propTypes = {
    title: PropTypes.string.isRequired,
    useGrid: PropTypes.bool,
    spacing: PropTypes.number,
    sx: PropTypes.object,
    children: PropTypes.node,
};
